<template>
  <ProSpaceRightPanel
    v-if="ids.length > 0"
    :header="header"
    :loading="loading"
    :has-error="hasError"
    @clear="clearPanel"
    @edit="editPanel"
    @delete="deletePanel"
    @show-history="showHistoryPanel"
  >
    <template v-if="ids.length === 1" v-slot:center>
      <ProSpacePanelBlock :header="headerKASs">
        <template #header>
          <ProSpaceAction :text="$t('editItemTxt')" @click="editPanel" />
        </template>
        <ProSpacePanelBlockList :list="content" />
      </ProSpacePanelBlock>
    </template>
    <template v-if="ids.length === 1" v-slot:bottom>
      <ProSpacePanelBlock :header="headerBottom">
        <template v-slot>
          <ProSpacePanelBlockList :list="contentBottom" />
        </template>
      </ProSpacePanelBlock>
    </template>
  </ProSpaceRightPanel>
</template>

<script>
import {
  ProSpaceRightPanel,
  ProSpaceTabs,
  ProSpacePanelBlock,
  ProSpacePanelBlockList,
  ProSpaceAction,
} from "@prospace/prospace-components-library";
import { KASService } from "../../../services/KASService";
import { mapGetters } from "vuex";
import {getAMorPM} from "@prospace/prospace-components-library/src/lib-assets/mixins/date";
export default {
  name: "KASPanel",
  components: {
    ProSpaceRightPanel,
    ProSpaceTabs,
    ProSpacePanelBlock,
    ProSpacePanelBlockList,
    ProSpaceAction,
  },
  props: {
    options: {
      type: Array,
      default: () => {
        return [];
      },
    },
    ids: {
      type: Array,
      required: true,
    },
    checkAccess: {
      type: Function,
    },
  },
  data() {
    return {
      kAS: null,
      kASService: new KASService(),
      loading: false,
      hasError: false,
    };
  },
  computed: {
    ...mapGetters({
      userinfo: "userinfoStore/getUserinfo",
      getFormatDateTime: "userinfoStore/getFormatDateTime"
    }),
    headerKASs() {
      return {
        title: this.$t("overview"),
        isExpand: false,
      };
    },
    headerBottom() {
      return {
        title: this.$t("metaInfTxt"),
        isExpand: true,
      };
    },
    tabs() {
      return [{ name: this.$t("overview"), isActive: true }];
    },
    header() {
      if (this.kAS) {
        return {
          title: this.kAS.value,
          id: this.ids[0],
          status: this.getStatus(this.kAS.status),
          options: this.options,
          showCounter: false,
        };
      }
      return {
        title: this.$t("itemsSelected"),
        counter: this.ids.length,
        showCounter: true,
        cleareble: true,
      };
    },
    content() {
      let content = [];
      if (this.kAS) {
        content.push([{ title: this.$t("kASValue"), text: this.kAS.value }]);
        if (this.checkAccess && this.checkAccess("agencyValue-rightPanel"))
            content.push([{ title: this.$t("kASAgencyValue"), text: this.kAS.agencyValue }]);
      }
      return content;
    },
    contentBottom() {
      if (this.kAS) {
        return [
          [
            {
              title: this.$t("createdByTxt"),
              text: this.kAS.createdBy,
            },
            {
              title: this.$t("updatedByTxt"),
              text: this.kAS.updatedBy,
            },
          ],
          [
            {
              title: this.$t("createdAtTxt"),
              text: this.getFormatDateTime(this.kAS.createdAt) + ' ' + getAMorPM(this.kAS.createdAt, this.userinfo?.timeFormat),
            },
            {
              title: this.$t("lastUpdatedTxt"),
              text: this.getFormatDateTime(this.kAS.lastUpdated) + ' ' + getAMorPM(this.kAS.lastUpdated, this.userinfo?.timeFormat),
            },
          ],
        ];
      }
      return [];
    },
  },
  mounted() {
    this.update();
  },
  watch: {
    ids() {
      this.update();
    },
  },
  methods: {
    update() {
      this.hasError = false;
      try {
        this.getKAS();
      } catch (e) {
        this.hasError = true;
      }
    },
    getKAS() {
      if (this.ids.length === 1) {
        this.loading = true;
        this.kASService.get(this.ids[0]).then((res) => {
          this.kAS = res.data;
          this.loading = false;
        });
      }
      this.kAS = null;
    },
    getStatus(status) {
      if (!status) return;
      return {
        type: status === "ACTIVE" ? "success" : "danger",
        text: status[0].toUpperCase() + status.toLowerCase().slice(1),
      };
    },
    clearPanel() {
      this.$emit("clear");
    },
    editPanel() {
      this.$emit("edit", this.kAS);
    },
    deletePanel() {
      this.$emit("delete", this.kAS);
    },
    showHistoryPanel() {
      this.$emit("history", this.kAS);
    },
  },
};
</script>

<style scoped></style>
